import {useEffect} from 'react';
import Box from '@mui/material/Box';
import { format, parseISO } from 'date-fns';

import { useSessionContext } from '../../../contexts/SessionContext';

import mapboxgl from 'mapbox-gl';

// @ts-ignore
// eslint-disable-next-line import/no-webpack-loader-syntax, import/no-unresolved
mapboxgl.workerClass = require('worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker').default;


export default function LoadListDetailsMap( props ) {
    console.debug("RTS Break LoadListDetailsMap");

    const {mapBoxKey} = useSessionContext();


    useEffect(() => {

        const map = new mapboxgl.Map({
            container: "mapContainer",
            accessToken: mapBoxKey,
            style: "mapbox://styles/mapbox/streets-v11",
            center: [-85.0716746, 33.5666694],
            zoom: 9
        });


        var maxLng = 0, maxLat = 0, minLng = 0, minLat = 0, markerCount = 0, rowCount = 0;
        var sw, ne, llb;


        if(props.data.tracker!==null){
            if(props.data.tracker.locations!=null){

                let zoomDistance = 100000;
                switch(props.mapZoomIdx){
                    case 0: 
                        zoomDistance = 10000;
                        break;

                    case 1:
                        zoomDistance = 5000;
                        break;

                    case 2:
                        zoomDistance = 2500;
                        break;

                    case 3:
                        zoomDistance = 1000;
                        break;

                    case 4:
                        zoomDistance = 0;
                        break;
                }

                const rawPoints = props.data.tracker.locations;

                let filterPoints = rawPoints.filter((ld, idx) => {
                    if(idx === 1){
                        return ld;
                    }
                    else{
                        if(ld.lat !== "-91" && ld.lng !== "-181" && ld.distanceDelta >= zoomDistance){
                            return ld;
                        }
                    }
                });

                let points = filterPoints.reverse();

                points.map((ld, idx) => {
                    //props.data.tracker.locations.slice(0).reverse().map((ld, idx) => {
                    //if(ld.lat !== "-91" && ld.lng !== "-181" && ld.distanceDelta >= zoomDistance){
                        const coord = {lat:ld.lat, lng:ld.lng};
                        rowCount = points.length -1;
                        markerCount++;

                        // Start the bounding box for the display.
                        if (markerCount === 1) {
                            minLng = maxLng = ld.lng // longitude
                            minLat = maxLat = ld.lat; // latitude
                        }
                        else {
                            maxLng = ld.lng > maxLng ? ld.lng : maxLng;
                            minLng = ld.lng < minLng ? ld.lng : minLng;
                            maxLat = ld.lat  > maxLat ? ld.lat  : maxLat;
                            minLat = ld.lat  < minLat ? ld.lat  : minLat;
                        }

                        // Start building the points.
                        const elMarker = document.createElement('div');

                        if(idx === rowCount){
                            if(props.data.returnedDate === null){
                                elMarker.className = "rtsMarkerSmallCur";
                            }
                            else{
                                elMarker.className = "rtsMarkerSmallRet";
                            }
                        }
                        else{
                            if(props.data.pulls.length === 0){
                                elMarker.className = "rtsMarkerSmallInit";
                            }
                            else{
                                let wipDate = new Date(props.data.pulls[0].pullDate);
                                let locDate = new Date(ld.locTimeStamp);

                                if(locDate < wipDate){
                                    elMarker.className = "rtsMarkerSmallInit";
                                }
                                else{
                                    if(props.data.pickupRequestDate !== null){
                                        let markDate = new Date(ld.pickupRequestDate);
                                        if(locDate < markDate){
                                            elMarker.className = "rtsMarkerSmallWip";
                                        }
                                        else{
                                            elMarker.className = "rtsMarkerSmallRet";
                                        }
                                    }
                                    else{
                                        elMarker.className = "rtsMarkerSmallWip";
                                    }
                                }
                            }
                        }
                        const elNum = document.createElement('span');
                        elNum.className = "rtsLightForeground";
                        //elNum.innerHTML = (props.data.tracker.locations.length - markerCount) +1;
                        elNum.innerHTML = markerCount;
                        elMarker.appendChild(elNum)                    

                        var serNum = props.data.reel==null?'':props.data.reel.serialNumber;

                        let marker = new mapboxgl.Marker(elMarker)
                            .setLngLat(coord)
                            .setPopup(new mapboxgl.Popup({offset: 30})
                            .setHTML('<div><label style="font-size:1.5em; font-Weight:bold;">' + serNum + '</label></div>'
                                + '<div><label style="font-Weight:bold; padding-top:5px;">Location Information</span></div>'
                                + '<div><label style="padding-left:5px;">Date:</label><span>' + format(parseISO(ld.locTimeStamp), "MM-dd-yyyy") + '</span></div>'
                                + '<div><label style="padding-left:5px;">Latitude:</label><span>' + ld.lat + '</span></div>'
                                + '<div><label style="padding-left:5px;">Longitude:</label><span>' + ld.lng + '</span></div>'
                                ));

                        marker.addTo(map);
                        return marker;
                    //}
                });

                sw = new mapboxgl.LngLat(minLng, minLat);
                ne = new mapboxgl.LngLat(maxLng, maxLat);
                llb = new mapboxgl.LngLatBounds(sw, ne);

                if(rowCount > 0){
                    if(rowCount === 1){
                        map.setCenter(sw);
                    }
                    else{
                        map.fitBounds(llb,
                            {
                                padding: { top: 50, bottom: 50, left: 50, right: 50 } ,
                                animate: false
                            }
                        );   
                    }
                }  
            }
        }
        else{
            if(props.data.setLocations!==null){
    
                props.data.setLocations.map((ld, idx) => {
                    const coord = {lat:ld.lat, lng:ld.lng};
                    markerCount++;

                    if (markerCount === 1) {
                        minLng = maxLng = ld.lng // longitude
                        minLat = maxLat = ld.lat; // latitude
                    }
                    else {
                        maxLng = ld.lng > maxLng ? ld.lng : maxLng;
                        minLng = ld.lng < minLng ? ld.lng : minLng;
                        maxLat = ld.lat  > maxLat ? ld.lat  : maxLat;
                        minLat = ld.lat  < minLat ? ld.lat  : minLat;
                    }

                    const elMarker = document.createElement('div');

                    if(markerCount === 1){
                        elMarker.className = "rtsMarkerSmallCur";
                    }
                    else{
                        if(props.data.pulls.length === 0){
                            elMarker.className = "rtsMarkerSmallInit";
                        }
                        else{
                            let wipDate = new Date(props.data.pulls[0].pullDate);
                            let locDate = new Date(ld.createDate);

                            if(locDate < wipDate){
                                elMarker.className = "rtsMarkerSmallInit";
                            }
                            else{
                                if(props.data.returnMarkDate != null){
                                    let markDate = new Date(ld.returnMarkDate);
                                    if(locDate < markDate){
                                        elMarker.className = "rtsMarkerSmallWip";
                                    }
                                    else{
                                        elMarker.className = "rtsMarkerSmallRet";
                                    }
                                }
                                else{
                                    elMarker.className = "rtsMarkerSmallWip";
                                }
                            }
                        }
                    }
                    const elNum = document.createElement('span');
                    elNum.className = "rtsLightForeground";
                    elNum.innerHTML = (props.data.setLocations.length - markerCount) +1;
                    elMarker.appendChild(elNum)                    

                    var serNum = props.data.reel==null?'':props.data.reel.serialNumber;

                    let marker = new mapboxgl.Marker(elMarker)
                        .setLngLat(coord)
                        .setPopup(new mapboxgl.Popup({offset: 30})
                        .setHTML('<div><label style="font-size:1.5em; font-Weight:bold;">' + serNum + '</label></div>'
                            + '<div><label style="font-Weight:bold; padding-top:5px;">Location Information</span></div>'
                            + '<div><label style="padding-left:5px;">Date:</label><span>' + format(parseISO(ld.createDate), "MM-dd-yyyy") + '</span></div>'
                            + '<div><label style="padding-left:5px;">Latitude:</label><span>' + ld.lat + '</span></div>'
                            + '<div><label style="padding-left:5px;">Longitude:</label><span>' + ld.lng + '</span></div>'
                            ));

                    marker.addTo(map);
                    return marker;
                });

                sw = new mapboxgl.LngLat(minLng, minLat);
                ne = new mapboxgl.LngLat(maxLng, maxLat);
                llb = new mapboxgl.LngLatBounds(sw, ne);

                if(markerCount > 0){
                    if(markerCount === 1){
                        map.setCenter(sw);
                    }
                    else{
                        map.fitBounds(llb,
                            {
                                padding: { top: 50, bottom: 50, left: 50, right: 50 } ,
                                animate: false
                            }
                        );   
                    }
                }  
            }
        }
    }, [props, mapBoxKey]); 
    

    return(
        <Box 
            id="mapContainer"
            className="map" 
            style={{minHeight:"300px"}}  
        />
    );
}
